export function VideoHighlight() {
  return (
    <section 
      id="Section_Video-Highlight_Home" 
      className="section_video-highlight home-page-video py-20 bg-white"
    >
      <div className="container-main max-w-6xl mx-auto px-4">
        <div className="heading-text-stack_wrapper text-center mb-12">
          <h3 className="h1---h1_medium text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            <strong className="bold-text">Unlock Access to Aviation</strong>
          </h3>
          <p className="p---body-text centered text-lg text-gray-700 max-w-3xl mx-auto">
            <strong className="bold-text-2">
              From discovery flight to private pilot certificate to airplane ownership, 
              watch one pilot's journey with Crystal Air.
            </strong>
          </p>
        </div>
        
        <div 
          className="video_highlight w-full relative"
          style={{ paddingTop: '56.27659574468085%' }}
        >
          <iframe 
            className="embedly-embed absolute top-0 left-0 w-full h-full rounded-lg shadow-lg"
            src="//cdn.embedly.com/widgets/media.html?src=https%3A%2F%2Fplayer.vimeo.com%2Fvideo%2F893417313%3Fapp_id%3D122963&dntp=1&display_name=Vimeo&url=https%3A%2F%2Fvimeo.com%2F893417313&image=https%3A%2F%2Fi.vimeocdn.com%2Fvideo%2F1767159534-03bc80450cd78bb76e874ce0f0973bdb0f3d631aba78db9988a291c66393aa57-d_1280&key=96f1f04c5f4143bcb0f2e68c87d65feb&type=text%2Fhtml&schema=vimeo" 
            width="940" 
            height="529" 
            scrolling="no" 
            allowFullScreen 
            title="Crystal Air - Flight Instruction"
          />
        </div>
      </div>
    </section>
  );
}